import { Component, Inject, ViewChild,ElementRef,OnInit, OnDestroy } from '@angular/core';
// import { AppConfigService } from 'src/app/shared/services/app-config/app-config.service';
// import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TwilioHelperService } from 'src/app/shared/services/twilio-helpers.service';
import { interval, Subject,takeUntil } from 'rxjs';
import { Constants } from 'src/app/shared/constants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalDataService } from 'src/app/shared/services/local-data.service';
import { LocalizationService } from 'src/app/shared/localization/localization.service';

@Component({
    selector: 'app-incoming-call',
    templateUrl: './incoming-call.component.html',
    styleUrls: ['./incoming-call.component.scss']
})
export class IncomingCallComponent implements OnInit, OnDestroy {
    counter: any;
    dataLoading: boolean = false;
    counterSubscribe: any;
    timeout: boolean = false;
    userStatus = Constants.USER_CURRENT_STATUS;
    silenceCall: boolean = false;
    g3msResult: any = { contractInfo: {}, callDetails: {} };
    countryConfig: any = { enableDataTracks: false }
    home: any = { isChatCollapse: false }
    incidentDetailsList: any = [];
    @ViewChild('twilioRingtone', { static: true })
    public ringtone!: ElementRef<HTMLAudioElement>;
    private audioContext: AudioContext | null = null;
    selectedAgentStatus: any = {
        selectedStatus: undefined,
        prevSelStatus: undefined,
        onCallbackStatus: undefined
    };
    destroy$ = new Subject<void>();
    private _elevatorCallService: any;
    private _localCookies: any;
    constructor(public _dialogRef: MatDialogRef<IncomingCallComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: any,
        private _localDataService: LocalDataService,
        public _localizationService: LocalizationService,
        public _twilioHelperService: TwilioHelperService,
        private router: Router) {
        _localDataService.selectedScreen = ['elevator_call_details','dashboard'];
        _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, ..._localDataService.selectedScreen]);
        this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)(); 
        this.counter = _data.notifiTimeLeft;
        this.counterSubscribe = interval(1000).subscribe((x = 1) => {
            this.counter = _data.notifiTimeLeft - x;
            if (this.counter == 0) {
                this.counterSubscribe.unsubscribe();
                this.timeout = true;
                this.ringtone?.nativeElement.pause();                 
            }
        });
        this._twilioHelperService.agentStatusEmit.subscribe({
            next: (result: any) => {
                this.selectedAgentStatus = result;
                ////console.log('Incomingcall component',this.selectedAgentStatus);
            }
        });
        this.ringtone?.nativeElement?.play();
        if (!_data.status) {
            this.onDialogCancel();
        }        
    }
    ngOnInit(): void {     
        
        try {
            if (this.ringtone.nativeElement) {
                try{
                //this.ringtone.nativeElement.volume = this._localDataService.ecd.currentUser.volume;
                this.ringtone.nativeElement.volume = 0.9;
                //console.log('Ring volume:',this.ringtone.nativeElement.volume);
                }
                catch(e)
                {
                    console.log('ring tone error',e);
                }
                ////this.ringtone.nativeElement.volume = 55;
                var promise = this.ringtone.nativeElement.play();
                if (promise !== undefined) {
                    promise.then(() => {
                        // Autoplay started
                    }).catch((error: any) => {
                        // Autoplay was prevented.
                        if (this.ringtone?.nativeElement) {
                            this.ringtone.nativeElement.muted = true;
                            this.ringtone?.nativeElement?.play();
                        }
                    });
                }
            }
        }
        catch (e: any) {
            //this._commonService.logException({ "methodName": "AcceptTheCall.playRingTone", "exceptionDetails": e.message + " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        }
        this._twilioHelperService.callInfo.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
            {
                if (data != null || data != undefined) {
                //console.log('Test data:',data)
                this._data.buildingName=data.buildingName;
                this._data.buildingAddress=data.buildingAddress;
                this._data.branchName=data.branchName;
                }              
            }
        });  
    }    
    acceptTheCall() {
        this.ringtone?.nativeElement?.pause();
        if (this.timeout == false) {
            this.counterSubscribe.unsubscribe();
            this._twilioHelperService.acceptTheCall();            
        }
    }
    silenceTheCall() {
        this.silenceCall = true;
        this.ringtone?.nativeElement.pause();
    }
    onDialogCancel(): void {
        this.counterSubscribe.unsubscribe()
        this._dialogRef.close();
    }
    /*
     * Method to change user activity & user status.
     * UpdateUserActivtity: will update the user status offline in Twilio.
     * UpdateActivity: will update the activity to CCC database.
   */
    changeAgentStatus(currentStatus: any, isFromModel: any, isUserRequest: boolean = false) {
        this.counterSubscribe.unsubscribe();
        this._dialogRef.close();
        if (currentStatus != undefined)
            currentStatus="Idle";
            this._twilioHelperService.changeStatus(currentStatus, isFromModel, isUserRequest)
    }
     ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
